<template>
  <div style="width: 100%;">
    <el-row justify="start" align="middle" type="flex" style="border-top: 1px solid lightgray;">
      <el-col :span="12" class="h-padded v-padded-s left-aligned-col">
        <el-row type="flex" justify="start" align="middle">
          <div style="display: inline-block">
            <h4 style="margin: 0; font-weight: 100;">Distribution Lines</h4>
          </div>
          <div style="display: inline-block; margin: 0 12px;">
            <el-tag v-if="fetchingPoLines" type="primary">
              <el-icon class="is-loading" style="margin: 0 6px;"><Loading/></el-icon>Fetching Vendor PO Lines
            </el-tag>
            <el-tag v-if="requirementsNotMet.length" type="warning">
              <el-icon style="margin: 0 6px;"><WarningFilled/></el-icon>Incomplete lines
            </el-tag>
          </div>
        </el-row>
      </el-col>
      <el-col :span="12" class="h-padded v-padded-s right-aligned-col">
        <el-row type="flex" align="middle" justify="end">
          <el-col>
            <div style="display: block;">
              <el-button
                v-if="parentForm && ['POSTED', 'CLOSED'].includes(parentForm.status)"
                type="default"
                @click.stop="openHistoryDialog"
                :disabled="isHistoryLoading"
                tabindex="-1">
                History
                <b-spinner class="me-2" small v-if="isHistoryLoading"/>
              </el-button>
              <el-button
                v-if="isPasted"
                type="danger"
                @click="resetLines"
                :disabled="readOnly"
                tabindex="-1">
                Clear All Lines
              </el-button>
              <el-button
                v-if="preventPasteValues"
                type="info"
                @click="toggleHotPaste()"
                :disabled="readOnly"
                tabindex="-1">
                Paste Values
              </el-button>
              <el-button
                type="default"
                @click="addNewLines(20)"
                :disabled="readOnly || preventAddLine"
                tabindex="-1">
                Add line
              </el-button>
               <el-button
                v-if="entityType === 'po' && showReopenPoBtn && !showClosePoBtn"
                @click="$emit('reopenPo', true)">
                Reopen PO
              </el-button>
              <el-button
                v-if="entityType === 'po' && showClosePoBtn"
                :disabled="!hasEditPermission"
                @click="$emit('closePo', true)">
                Close PO
              </el-button>
              <el-button
                v-if="entityType === 'po' && showDeletePoBtn"
                :disabled="!hasDeletePermission"
                @click="$emit('deletePo', true)">
                Delete PO
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div style="width: 100%;">
      <el-row type="flex" justify="center" align="middle" id="form_container" ref="formContainer">
        <el-form ref="lines-form">
          <table id="dist-lines" style="margin: 0; border: 1px solid lightgrey;">
            <tbody>
            <tr>
              <template v-for="f in fields"><td style="text-align: left; padding-left: 6px;" v-if="!f.hidden" :width="f.fieldWidth">
                {{ f.required ? `*${f.label}` : f.label}}
              </td></template>
              <td width="3%" style="text-align: center;" v-if="!hideDeleteBtn">
                <el-icon><Delete/></el-icon>
              </td>
              <td width="3%" style="text-align: center;" v-if="(entityType !== 'po' && (linesContainDcs || !readOnly) && parentForm.status)">
                DCs
              </td>
            </tr>
            <DistributionLine
              v-for="(line, lineIndex) in lines"
              :key="`line${lineIndex}`"
              :line_number="line.line_number"
              :original="line.form"
              :fields="fields"
              :isLastRow="lineIndex === lines.length - 1"
              :readOnly="readOnly"
              :showCloseBtn="showClosePoBtn"
              :showReopenBtn="showReopenPoBtn"
              :querySearch="querySearch"
              :saveErr="line.saveErr"
              :hideDeleteBtn="hideDeleteBtn"
              :entityType="entityType"
              :willBeDeleted="line.deleteLine"
              :totalLines="lines.length"
              :trxStatus="parentForm ? parentForm.status : null"
              :linesContainDcs="linesContainDcs"
              :fieldsToClear="fieldsToClear"
              :splits="line.splits || null"
              :splitBy="line.splitBy || null"
              :isSplittingLine="line.isSplittingLine || false"
              :maxAmtAfterSplit="maxAmtsAfterSplit"
              :hasEditPermission="hasEditPermission"
              @viewDc="(offsetLine) => $emit('viewDc', offsetLine)"
              @lineModified="(payload) => $emit('lineModified', payload)"
              @itemFieldChanged="fetchInheritedMarkupData"
              @trackChangedLines="trackChangedLines"
              @lineAmountChanged="(line) => $emit('lineAmountChanged', line)"
              @updateFocus="updateFocus"
              @checkAutocompleteField="checkAutocompleteField"
              @lineChanged="updateLine"
              @deleteLine="handleLineDeletion"
              @closeLine="closeLine"
              @reopenline="reopenline"
              @requirementsNotMet="handleRequirementsNotMet"
              @splitLine="showSplitLineModal"
              @updateMaxAmtAfterSplit="updateMaxAmtAfterSplit"
              :lineAccounts="lineAccounts"
            />
            </tbody>
          </table>
        </el-form>
      </el-row>
    </div>
    <el-row justify="start" align="middle" type="flex" style="border-top: 1px solid lightgray;">
      <el-col class="h-padded v-padded-s right-aligned-col">
        <el-row type="flex" align="bottom" justify="end">
          <el-col>
            <div style="display: block;">
              <el-button
                v-if="isPasted"
                type="danger"
                @click="resetLines"
                :disabled="readOnly"
                tabindex="-1">
                Clear All Lines
              </el-button>
              <el-button
                v-if="preventPasteValues"
                type="info"
                @click="toggleHotPaste()"
                :disabled="readOnly"
                tabindex="-1">
                Paste Values
              </el-button>
              <el-button
                type="default"
                @click="addNewLines(20)"
                :disabled="readOnly || preventAddLine"
                tabindex="-1">
                Add line
              </el-button>
              <el-button
                v-if="entityType === 'po' && showReopenPoBtn && !showClosePoBtn"
                @click="$emit('reopenPo', true)">
                Reopen PO
              </el-button>
              <el-button
                v-if="entityType === 'po' && showClosePoBtn"
                :disabled="!hasEditPermission"
                @click="$emit('closePo', true)">
                Close PO
              </el-button>
              <el-button
                v-if="entityType === 'po' && showDeletePoBtn"
                :disabled="!hasDeletePermission"
                @click="$emit('deletePo', true)">
                Delete PO
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <SplitLineModal v-if="lineToSplit" :lineNumber="lineToSplit" @splitLine="handleSplitLine" />
    <el-dialog
      title="Paste in Values"
      v-model="visible.hotPaste"
      width="90%"
      id="hot-paste-dialog"
      ref="hot-paste-dialog"
      top="5%"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <hot-paste :entityType="entityType" :dialog-size="getFormSize()" @import="importLines" />
    </el-dialog>
    <div v-if="showHistory">
      <TransactionHistory :transactionInfo="transactionInfo" :visible="showHistory" @closeHistoryDialog = "showHistory = false" :key="render"/>
    </div>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  /* eslint-disable camelcase */
  import { mapGetters } from 'vuex'
  import DistributionLine from '@/components/Line.vue'
  import SplitLineModal from '@/components/SplitLineModal.vue'
  import { isNumeric } from '@/utils/helpers/Validate'
  import buildNoDataObject from '@/utils/helpers/BuildNoDataObject'
  import HotPaste from './HotPaste.vue'
  import { lineMixins } from '@/Mixins/Lines'
  import Mousetrap from 'mousetrap'
  import TransactionHistory from '@/components/TransactionHistory.vue'

  export default {
    mixins: [ lineMixins ],
    components: {
      DistributionLine,
      SplitLineModal,
      HotPaste,
      TransactionHistory
    },
    props: {
      fields: Array,
      initLines: Number,
      entityType: String,
      existingLines: Array,
      readOnly: Boolean,
      parentForm: Object,
      fieldsToClear: Array,
      fieldsToRemove: Array,
      customFields: Array,
      closedPoLineToUpdate: Number,
      reset: { type: Boolean, default: false },
      fetchingPoLines: Boolean,
      vendorPoLines: Array,
      showClosePoBtn: Boolean,
      showDeletePoBtn: Boolean,
      showReopenPoBtn: Boolean,
      createLines: Object
    },
    data () {
      return {
        lines: [],
        suggestions: { // TODO: deprecated
          active: { line: '', field: '' },
          relieves: [],
          third_party_vendor: []
        },
        errors: [],
        loading: false,
        loadingOpts: false,
        lineAdded: false,
        preventEmitUpdateEvent: false,
        buildingLines: false,
        visible: { hotPaste: false },
        isPasted: false,
        searchTimeout: null,
        poLines: [], // TODO: check if still used
        currentFocus: null,
        lineToDelete: null,
        changedLines: {},
        reliefFieldOpts: [], // TODO: check if still used
        inheritedMarkupData: {},
        requirementsNotMet: [],
        lineToSplit: null,
        maxAmtsAfterSplit: {},
        lineAccounts: [],
        isHistoryLoading: false,
        showHistory: false,
        transactionInfo: {},
        render: 0,
        transactionId: this.$route.params.id
      }
    },
    methods: {
      // Vue 3: $children (via @vue/compat INSTANCE_CHILDREN) returns EVERY child of lines-form, not only the
      // <Line> instances, and no longer in a guaranteed index==line_number order. Filter to real Line
      // components (only they expose modifyLine) and look them up by line_number instead of array position.
      lineComponents () {
        const form = this.$refs['lines-form']
        return ((form && form.$children) || []).filter(c => c && typeof c.modifyLine === 'function')
      },
      lineByNumber (lineNumber) {
        return this.lineComponents().find(c => c.line_number === lineNumber) || null
      },
      async openHistoryDialog () {
        // Show loading when we click on the 'History' button
        this.isHistoryLoading = true
        // Check 'transactionId' is exist or not, if not 'return' nothing
        if (!this.transactionId) {
          this.isHistoryLoading = false
          return
        }
        let entity = { 'ap': 'aps', 'pc': 'pcs', 'po': 'pos', 'je': 'jes', 'pp': 'pps' }
        if (this.entityType === 'ap') this.transactionInfo['id'] = this.getApById(this.transactionId).ledger
        else if (this.entityType === 'pc') this.transactionInfo['id'] = this.getPcById(this.transactionId).ledger
        else if (this.entityType === 'je') this.transactionInfo['id'] = this.getJeById(this.transactionId).ledger
        else if (this.entityType === 'pp') this.transactionInfo['id'] = this.getPpById(this.transactionId).ledger
        else if (this.entityType === 'po') this.transactionInfo['id'] = 'PO' + this.getPoById(this.transactionId).id
        try {
          // Prepare API URL
          let url = `${entity[this.entityType]}/${this.transactionId}/instance_logs`
          // Get the response from the API
          const resp = await this.$store.dispatch('fetchTrasactionHistory', url)
          // Assign the response data to the 'transactionInfo' to show case in the form of table data
          this.transactionInfo.gridData = resp
          // Stop loading the 'History' button
          this.isHistoryLoading = false
          // Open the dialog box to show the transaction history
          this.showHistory = true
        } catch (error) {
          // Stop loading the 'History' button
          this.isHistoryLoading = false
          // Show the waring message
          this.$notify({ title: 'Warning', message: 'Try again!', type: 'warning', offset: 0 })
          console.log(error)
        }
      },
      /**
       * Displays the line splitting modal.
       * @param lineNumber
       */
      showSplitLineModal (lineNumber) {
        this.lineToSplit = lineNumber
      },
      /**
       * Handles the actual splitting of a line.
       * @param waysToSplit
       */
      handleSplitLine (waysToSplit) {
        this.insertLinesAtPosition({ lineNumber: this.lineToSplit, numberOfLinesToInsert: parseInt(waysToSplit) })
        const lineNumber = this.lineToSplit
        this.lineToSplit = null
        const endingIndex = parseInt(lineNumber) + parseInt(waysToSplit) // Set flag on splitting lines to indicate what these are.
        const maxAmtAllowed = parseFloat(this.lines[lineNumber - 1].form.amount_decimal)
        const presetLineAmt = (maxAmtAllowed / waysToSplit).toFixed(2)
        this.maxAmtsAfterSplit[lineNumber] = { originalAmt: maxAmtAllowed, remaining: maxAmtAllowed }
        this.lines[lineNumber - 1].form.amount_decimal = '0'
        this.lines[lineNumber - 1].splitBy = []
        if (this.lines[lineNumber - 1].isSplittingLine) {
          delete this.lines[lineNumber - 1].isSplittingLine
        }
        let totalOfSplittingLines = 0
        for (let i = lineNumber; i < endingIndex; i++) {
          this.lines[lineNumber - 1].splitBy.push(i + 1)
          this.lines[i].splits = lineNumber
          this.lines[i].splitMaxAmt = maxAmtAllowed // Set max allowable amount_decimal so we don't need to lookup the original line over and over again.
          if (i === endingIndex - 1) {
            this.lines[i].form.amount_decimal = (maxAmtAllowed - totalOfSplittingLines).toFixed(2) // Make sure amount of last line makes sum of splitting lines equal to amount of original line
          } else {
            this.lines[i].form.amount_decimal = presetLineAmt
            totalOfSplittingLines += parseFloat(presetLineAmt)
          }
        }
        this.updateLine({ num: lineNumber, form: { ...this.lines[lineNumber - 1].form } })
      },
      /**
       * Updates the maximum amount that a splitting line's amount_decimal value can be after user input.
       * @param splitLineNum      The line_number of the line that was split
       * @param splittingLineNum  The line_number the current splitting line
       */
      updateMaxAmtAfterSplit (splitLineNum, splittingLineNum) {
        let sumOfSplittingLines = 0
        let i = true
        let next = 0
        while (i === true) {
          const line = this.lines[splitLineNum + next]
          if (line && line.splits && line.splits === splitLineNum) {
            sumOfSplittingLines += parseFloat(line.form.amount_decimal || 0)
          } else {
            i = false
          }
          next++
        }
        this.maxAmtsAfterSplit[splitLineNum].remaining = this.maxAmtsAfterSplit[splitLineNum].originalAmt - sumOfSplittingLines
        if (this.maxAmtsAfterSplit[splitLineNum].remaining < 0) {
          this.handleMaxSplittingLineAmtExceeded(splittingLineNum)
        }
      },
      handleMaxSplittingLineAmtExceeded (lineNum) {
        console.log('max amount exceeded', lineNum)
      },
      /**
       * Handles a 'requirementsNotMet' event emitted from a DistributionLine component
       * @param data  An object describing the line number and whether or not its requirements have been met
       */
      handleRequirementsNotMet (data) {
        if (data.requirementsNotMet) {
          this.requirementsNotMet.push(data.line)
          this.requirementsNotMet = [...new Set(this.requirementsNotMet)]
        } else {
          this.requirementsNotMet = this.requirementsNotMet.filter(lineNumber => lineNumber !== data.line)
        }
      },
      /**
       * Tracks which lines have been changed
       * @param data    The line number and whether or not it has been changed
       */
      trackChangedLines (data) {
        if (data && data.changed) {
          this.changedLines[data.line_number] = true
        } else if (data && !data.changed) {
          delete this.changedLines[data.line_number]
        }
        if (Object.keys(this.changedLines).length) {
          this.$emit('linesHaveBeenChanged', true)
        } else {
          this.$emit('linesHaveBeenChanged', false)
        }
      },
      /**
       * Formats money fields to currency format
       * TODO: deprecated since we're now using MoneyField component
       */
      formatLineMoneyFields (data) {
        const { lineIndex, fieldName } = data
        if (this.lines[lineIndex].form[fieldName]) {
          let tmp = Object.assign({}, this.lines[lineIndex].form)
          tmp[fieldName] = Number(this.lines[lineIndex].form[fieldName]).toFixed(2)
          this.lines[lineIndex].form = Object.assign({}, tmp)
        }
      },
      /**
       * Governs whether the line closing modal is visible
       */
      closeLine (lineId) {
        this.$emit('closeLine', lineId)
      },

      reopenline (lineId) {
        this.$emit('reopenline', lineId)
      },
      /**
       * Returns the actual size of a form element
       * @return {*}
       */
      getFormSize () {
        let ref = this.$refs['formContainer']
        // Vue 3: component refs are proxies whose get-trap returns undefined for hasOwnProperty, so
        // ref.hasOwnProperty('$el') threw "not a function". Check for $el directly instead.
        if (!ref || !ref.$el) return {}
        let element = ref.$el
        if (element.offsetWidth) {
          return { width: element.offsetWidth, height: element.offsetHeight }
        } else {
          return {}
        }
      },
      /**
       * Updates information on the currently focused field (this.currentFocus)
       * @param focusData
       */
      updateFocus (focusData) {
        this.currentFocus = focusData
      },
      /**
       * Checks autocomplete field on change event
       * @param fieldData
       */
      checkAutocompleteField (fieldData) {
        if (fieldData.ref && fieldData.e) {
          let isRequired
          if (!fieldData.hasOwnProperty('isRequired')) {
            const field = this.fields.find(field => fieldData.ref.name.includes(field.name))
            isRequired = field.required
          } else {
            isRequired = fieldData.isRequired
          }
          this.handleAutocompleteConditions(fieldData.ref, fieldData.e, isRequired)
        }
      },
      /**
       * Finds the first line that does not contain an account and amount
       * @return {number}
       */
      getFirstOpenLine () {
        return this.lines.findIndex(line => (line.form && !line.form.account.value && !line.form.amount_decimal))
      },
      /**
       * Handles an autocomplete input field query and returns relevant results
       * @param searchOpts
       * @param cb
       */
      querySearch (searchOpts, cb) {
        this.loadingOptions = true
        return this.$store.dispatch('searchWithQuery', searchOpts)
          .then(r => {
            this.loadingOptions = false
            return r
          })
          .catch(e => {
            console.log(e)
            cb([buildNoDataObject(this.currentFocus)])
          })
      },
      /**
       * Formats a field in a given line depending on whether the user is currently working
       * on that field and whether the value, if any, satisfies that field's requirements.
       * TODO: deprecate this method
       * @param lineNum
       * @param col
       */
      checkFormField (lineNum, col) {
        const lineIndex = lineNum - 1
        const fieldIndex = col - 1
        const fieldName = Object.keys(this.lines[lineIndex].form)[fieldIndex]
        const { form } = this.lines[lineIndex]
        if (!(form && Object.keys(form).length)) return
        const required = this.fields.filter(field => field.required).map(field => field.name)
        const missing = required.filter(name => (form[name] && form[name].hasOwnProperty('value'))
          ? !form[name].value
          : !form[name])
        if (this.userIsWorkingOnLine(required, missing)) {
          let target = document.querySelector(`[data-row="${lineNum}"][data-col="${col}"]`)
          if (missing.includes(fieldName) && target) {
            // target.style.backgroundColor = '#ff49493d'
          } else if (!missing.includes(fieldName) && target) {
            target.style.background = 'none'
          }
        }
      },
      /**
       * Returns whether or not a user is currently working on a given line
       * @param required
       * @param missing
       * @return {boolean}
       * TODO: refactor this
       */
      userIsWorkingOnLine (required, missing) {
        const preFilled = ['series', 'location', 'set']
        const remaining = [...new Set(required)].filter(x => !new Set(preFilled).has(x))
        const missingFromRemaining = [...new Set(missing)].filter(x => new Set(remaining).has(x))
        const missingFromPreFilled = [...new Set(missing)].filter(x => new Set(preFilled).has(x))
        if (missing.length === required.length) return false
        return !!(missingFromRemaining.length < 3 || missingFromPreFilled.length)
      },
      /**
       * Bind navigation keys to actions using Mousetrap
       */
      bindMousetrapToNavKeys () {
        if (this.$refs && this.$refs['lines-form']) {
          let formEl = this.$refs['lines-form'].$el
          let mousetrap = new Mousetrap(formEl)
          mousetrap.bind(['up', 'down', 'left', 'right'], this.handleArrowKeys)
          mousetrap.bind('tab', this.handleTabKey)
          mousetrap.bind('enter', this.handleEnterKey)
          // TODO: when you get to moving lines up or down, you could use mousetrap to set up a key combo that
          // TODO: allows the user to do just that (like shift + arrowup)
        }
      },
      isSuggestionDropdownOpen (ref) {
        if (!ref) return false
        const autocompleteOpen = ((ref.suggestions && ref.suggestions.length > 0) || ref.loading) && ref.activated
        const selectOpen = ref.dropdownMenuVisible !== undefined ? ref.dropdownMenuVisible : ref.expanded
        return !!(autocompleteOpen || selectOpen)
      },
      commitHoveredSelectOption (ref) {
        if (!(ref && typeof ref.selectOption === 'function' && ref.expanded)) return
        if (ref.states && ref.states.hoveringIndex < 0) ref.states.hoveringIndex = 0
        ref.selectOption()
      },
      /**
       * Handle grid navigation using arrow keys
       * @param e   Keypress event
       */
      handleArrowKeys (e) {
        let { row, col, fieldtype } = e.target.dataset
        let ref = this.currentFocus && this.currentFocus.ref ? this.currentFocus.ref : null
        if (!ref || !(e && e.target)) return
        switch (e.key) {
          case 'ArrowUp':
          case 'ArrowDown':
            if (!(['select', 'autocomplete'].includes(fieldtype) && this.isSuggestionDropdownOpen(ref))) {
              row = e.key === 'ArrowUp' ? `${parseInt(row) - 1}` : `${parseInt(row) + 1}`
            }
            break
          case 'ArrowLeft':
          case 'ArrowRight':
            const { selectionStart, value } = e.target
            if (!(['select', 'autocomplete'].includes(fieldtype) && this.isSuggestionDropdownOpen(ref))) {
              if (fieldtype !== 'checkbox' && e.key === 'ArrowRight' && value && (selectionStart !== value.length)) { // if a field has text in it, make sure that the cursor is at the end or beginning of the text before navigating
                return
              } else if (fieldtype !== 'checkbox' && e.key === 'ArrowLeft' && value && value.length && (selectionStart !== 0)) {
                return
              }
              col = e.key === 'ArrowLeft' ? `${parseInt(col) - 1}` : `${parseInt(col) + 1}`
            }
        }
        this.navigateCells(row, col)
      },
      /**
       * Handle grid navigation using tab key. If the field being tabbed out of is:
       * 1) Autocomplete: if suggestions are being displayed, selects the highlighted suggestion. If the user hasn't
       * hovered over/highlighted any suggestion, then it selects the first suggestion. After setting the selection,
       * paints the cell white. If there aren't any suggestions, but the field is required, then it paints the cell
       * either red or white depending on whether or not a value is present.
       * 2) Select: if the user is hovering over/has highlighted a suggestion, selects the highlighted suggestion.
       * 3) Input: if the active field name is 'description', sets this field as whatever the header description is.
       * Then synchronizes all valid lines with the parent component.
       * @param e   Keypress event
       */
      handleTabKey (e) {
        if (!(e && e.target && e.target.dataset && e.target.dataset.fieldtype)) return
        let ref = this.currentFocus && this.currentFocus.ref ? this.currentFocus.ref : e.target
        let { row, fieldtype, fieldname } = e.target.dataset
        const line = this.lines[row - 1]
        const isRequired = !!this.fields.find(f => f.name === fieldname).required
        if (fieldtype === 'autocomplete') {
          this.checkAutocompleteField({ ref, e, isRequired })
        } else if (fieldtype === 'select') {
          this.commitHoveredSelectOption(ref)
        } else if (this.$refs['lines-form'] && fieldtype === 'input' && e.target.name.includes('description') && !e.target.value) {
          let lineRef = this.lineByNumber(line.line_number)
          if (lineRef && lineRef.line && lineRef.line.account.value && typeof lineRef.modifyLine === 'function') {
            lineRef.modifyLine(fieldname, this.parentForm.description)
          }
        }
        this.syncLinesWithParent(this.getValidLines())
      },
      /**
       * Determines under which conditions to set an autocomplete field value
       * @param ref
       * @param e
       * @param isRequired
       */
      handleAutocompleteConditions (ref, e, isRequired) {
        if (!(ref && ref.suggestions)) {
          return
        }
        if (ref.suggestions.length > 0 && ref.highlightedIndex > -1) { // suggestion highlighted
          if (e && e.key === 'Tab') {
            ref.select(ref.suggestions[ref.highlightedIndex])
          }
          if (ref.$children && ref.$children.length) {
            let label = ref.suggestions[ref.highlightedIndex].label
            ref.$children[0].currentValue = label.includes(' - ') ? label.split(' - ')[0] : label // show code only after selection
          }
        } else if (ref.suggestions.length > 0 && ref.highlightedIndex === -1) { // no suggestion highlighted
          ref.select(ref.suggestions[0]) // This should actually never happen because the first suggestion should always be highlighted
        } else if (!ref.suggestions.length && !e.target.value && !isRequired) { // no suggestions
          e.target.style.background = 'none'
        }
      },
      /**
       * Handle grid navigation using enter
       * @param e   Keypress event
       */
      handleEnterKey (e) {
        const { currentFocus, navigateCells } = this
        if (!(e && e.target && e.target.dataset && e.target.dataset.fieldtype)) return
        let ref = currentFocus && currentFocus.ref ? currentFocus.ref : null
        let { row, col, fieldtype } = e.target.dataset
        const field = ref.name.split('__')[1]
        const newCol = `${parseInt(col) + 1}`
        const isRequired = this.fields.find(f => f.name === field).required || false
        if (fieldtype === 'autocomplete' && ref) {
          this.checkAutocompleteField({ ref, e, isRequired })
        } else if (fieldtype === 'select' && ref) {
          this.commitHoveredSelectOption(ref)
        }
        navigateCells(row, newCol)
      },
      /**
       * Handle grid navigation using arrow keys
       * @param row   The destination row
       * @param col   The destination col
       */
      async navigateCells (row = 1, col = 1) {
        const { lines, fields, vendorPoLines, modalVisible, navigateCells, addNewLine } = this
        row = parseInt(row)
        col = parseInt(col)
        const isLastRow = row && (row === lines.length)
        const isLastCol = col && (col === fields.length)
        const isLineAfterLast = row && (row - 1 === lines.length)
        const firstCol = vendorPoLines && vendorPoLines.length ? 1 : 2
        const navigate = () => {
          const destination = document.querySelector(`[data-row="${row}"][data-col="${col}"]`)
          if (destination) {
            destination.focus()
          }
        }
        if (!isLineAfterLast && !modalVisible && !(isLastRow && isLastCol)) {
          if (isLastCol) {
            navigateCells(row + 1, firstCol)
          } else {
            navigate()
          }
        } else if (isLineAfterLast || isLastCol) {
          if (isLineAfterLast && await addNewLine()) {
            navigateCells(lines.length, col)
          } else if (!isLineAfterLast && await addNewLine()) {
            navigateCells(lines.length, firstCol)
          }
        }
        this.syncLinesWithParent(this.getValidLines())
      },
      /**
       * Creates a new lines
       */
      addNewLines (count = null) {
        let defaultLength = this.lines.length
        const totalRows = defaultLength + count
        for (let i = defaultLength; i < totalRows; i++) {
          this.addNewLine()
          if (this.lines[i] && this.lines[i].form) {
            this.lines[i].form.line_number = i + 1
          }
        }
        console.log(this.lines)
      },
      /**
       * Creates a new line
       */
      addNewLine (count = null) {
        if (this.preventAddLine) { // Don't allow line additions as DCs
          return false
        }
        try {
          let form = this.buildLineForm()
          if (count) {
            const defaultLength = this.lines.length + 1
            for (let lineNum = 0; lineNum < count; lineNum++) {
              this.lines.push({ form, line_number: defaultLength + lineNum })
            }
          } else {
            const newLine = { form, line_number: this.lines.length + 1 }
            this.lines.push(newLine)
          }
          return true
        } catch (e) {
          console.log(e)
          return false
        }
      },
      /**
       * Adds an existing line
       * @param line        The existing line to add
       * @param isImported  Whether the line is an imported PO line, in which case the form doesn't
       * need to be built
       */
      addExistingLine (line, isImported = false, add = false) {
        const valid = this.getValidLines()
        let targetLineNumber
        let form = Object.assign({}, line.form || line)
        if (this.lines && this.lines.length) {
          if (valid && valid.length) {
            const lastLine = Math.max(...valid.map(l => l.line_number), 0)
            targetLineNumber = lastLine + 1
            form['line_number'] = targetLineNumber
          } else {
            targetLineNumber = form.line_number || 1
          }
          const lineToAdd = { line_number: targetLineNumber, form: this.buildLineForm(line) }
          if (line && !line.id && line.form && line.form.id) { // if it's an existing line and it has a form with an id
            this.lines.push({
              line_number: targetLineNumber,
              form: this.buildLineForm(form),
              isSplittingLine: line.isSplittingLine,
              splits: line.splits
            })
          } else if (line && line.id && !line.form) { // if it's an existing line with an id
            this.lines.push(lineToAdd)
            this.syncLinesWithParent(this.getValidLines())
          } else {
            if (targetLineNumber > this.lines.length) { // if there are more lines than the initial 20 and the current line number is past 20
              this.lines.push({ line_number: targetLineNumber, form: isImported ? form : this.buildLineForm(form) })
              this.syncLinesWithParent(this.getValidLines())
            } else {
              if (!line.line_number) {
                line.line_number = targetLineNumber
                line.form.line_number = targetLineNumber
              } else {
                if (isImported) {
                  line.line_number = targetLineNumber
                  line.form.line_number = targetLineNumber
                  this.lines[targetLineNumber - 1] = { line_number: targetLineNumber, form: this.buildLineForm(line) }
                  this.syncLinesWithParent(this.getValidLines())
                }
              }
              let component = this.lineByNumber(line.line_number)
              if (component) {
                component.line = Object.assign({}, component.line, line.form)
                for (let field in component.line) {
                  component.trackChanges(field)
                }
              }
            }
          }
        } else {
          targetLineNumber = form.line_number || 1
          this.lines.push({ line_number: targetLineNumber, form: this.buildLineForm(form), isSplittingLine: line.isSplittingLine })
        }
      },
      /**
       * Updates a line
       * @param payload
       */
      updateLine (payload) {
        const { num, form } = payload
        try {
          let line = this.lines.find(line => line.line_number === num)
          if (line && line.form) {
            line.form = Object.assign({}, line.form, form)
          }
          this.syncLinesWithParent(this.getValidLines())
          this.$emit('lineChanged', num)
        } catch (e) {
          console.log(e)
        }
      },
      /**
       * Syncs lines with parent component
       * @param lines     The lines that should be synced with the parent component
       */
      syncLinesWithParent (lines) {
        this.$emit('updateLines', lines)
      },
      /**
       * Returns only lines for which the minimum requirements have been met
       */
      getValidLines () {
        const required = {}
        this.fields.forEach(field => {
          if (field.required) required[field.name] = field
        })
        return this.lines.filter(line => {
          let validCount = 0
          for (let field in line.form) {
            if (this.entityType === 'ar' && field === 'type' && ['OFFSET', 'MARKUP', 'COGS'].includes(line.form.type)) {
              validCount = validCount + 1
              continue
            }
            if (!required.hasOwnProperty(field)) continue
            if (line.form[field] && line.form[field].hasOwnProperty('value') && line.form[field].value) {
              validCount = validCount + 1
            } else if (line.form[field] && !line.form[field].hasOwnProperty('value')) {
              validCount = validCount + 1
            }
          }
          return validCount === Object.keys(required).length
        })
      },
      /**
       * Selects method to handle line deletion, based on whether line already exists (has an ID) or not
       */
      handleLineDeletion (lineNum) {
        const valid = this.getValidLines().map(line => line.line_number)
        if (valid.includes(lineNum)) {
          this.markLineForDeletion(lineNum)
        } else {
          this.removeDeletedLines([lineNum], false)
        }
      },
      /**
       * Deletes a specified line
       * @param lineNum     The line number that corresponds to the line to be marked for deletion
       */
      markLineForDeletion (lineNum) {
        if (!(this.lines[lineNum - 1] && typeof this.lines[lineNum - 1] === 'object')) return false
        const markLines = () => {
          this.lines = this.lines.map(line => {
            if (line.line_number === lineNum) {
              let tmp = Object.assign({}, line)
              tmp.deleteLine = !tmp.deleteLine
              line = Object.assign({}, tmp)
            }
            return line
          })
        }
        markLines()
        this.syncLinesWithParent(this.getValidLines())
        this.$emit('lineChanged', lineNum)
      },
      /**
       * Removes a specified set of distribution lines, re-numbers the remaining lines, and
       * synchonizes all valid lines with the parent component.
       * @param linesToDelete       The list of line numbers that correspond to the lines to delete
       * @param reset               Whether line flags such as saveErr or deleteLine should be reset
       */
      removeDeletedLines (linesToDelete, reset = true) {
        const removeInvalidProperties = (line) => {
          let tmp = Object.assign({}, line)
          if (line.hasOwnProperty('deleteLine')) delete tmp.deleteLine
          if (line.hasOwnProperty(('saveErr'))) delete tmp.saveErr
          line = Object.assign({}, tmp)
          return line
        }
        this.lines = this.lines.filter(line => !linesToDelete.includes(line.line_number))
        let newLineOrderIndex = {}
        this.lines = this.lines.map((line, index) => { // Renumber lines
          const newNumber = index + 1
          newLineOrderIndex[line.form.line_number] = newNumber
          line.line_number = newNumber
          if (line.form) line.form.line_number = newNumber
          if (reset) line = removeInvalidProperties(line)
          return line
        })
        if (this.lines.length < 20) {
          const missing = (20 - this.lines.length)
          for (let i = 0; i < missing; i++) {
            this.addNewLine()
          }
        }
        this.syncLinesWithParent(this.getValidLines())
      },
      /**
       * Removes a distribution line, then re-assigns line numbers. Since there needs to be at least
       * 20 lines displayed, if the number of lines is greater than 20, simply filters the line to be deleted.
       * If the number of lines is 20 or less, clears the line, resets all changes for that particular
       * Line component, and un-highlights the line.
       * @param lineNum     The number of the line to remove
       */
      removeLine (lineNum) {
        if (this.lines.length > 20) {
          this.lines = this.lines.filter(line => line.line_number !== lineNum)
        } else {
          if (this.lines[lineNum - 1]) {
            this.lines[lineNum - 1].form = this.buildLineForm()
            const lineRef = this.lineByNumber(lineNum)
            if (lineRef) {
              lineRef.resetChanges()
            }
            this.unpaintLine(lineNum)
          }
        }
      },
      /**
       * Unpaints a line
       * @param lineNum     The line number of the line to un-highlight
       */
      unpaintLine (lineNum) {
        let lineRef = this.lineByNumber(lineNum)
        if (!lineRef) return
        lineRef.$children.forEach(field => {
          if (field.$el.tagName !== 'INPUT') {
            let target = field.$el.children[0].getElementsByTagName('INPUT')[0]
            if (target) {
              target.style.backgroundColor = 'none'
            }
          } else {
            field.$el.style.backgroundColor = 'none'
          }
        })
      },
      /**
       * Clears the distribution lines without resetting the header.
       * @return {boolean}
       */
      resetLines () {
        this.isPasted = false
        const linesToDelete = this.lines.map(line => line.line_number)
        let savedLines = this.lines.filter(l => l.form.id)
        this.deleteClearedLines(savedLines)
        this.removeDeletedLines(linesToDelete)
        return true
      },
      /**
       * Highlights all lines that failed to save
       * @param failedLines   List of lines that failed to save
       */
      highlightFailedLines (failedLines) {
        this.lines = this.lines.map(line => {
          if (failedLines.includes(line.line_number)) {
            line.saveErr = true
          }
          return line
        })
      },
      /**
       * Highlights all lines that failed to save
       * @param failedLines   List of lines that failed to save
       */
      unHighlightFailedLines (failedLines) {
        this.lines = this.lines.map(line => {
          if (failedLines.includes(line.line_number) && line.hasOwnProperty('saveErr')) {
            delete line.saveErr
          }
          return line
        })
      },
      /**
       * Enables pasting values using HandsOnTable
       */
      toggleHotPaste () {
        this.visible.hotPaste = !this.visible.hotPaste
      },
      /**
       * Method to sync data between HotPaste component, DistributionLines, and parent component
       * @param pastedLines
       * @return {boolean}
       */
      importLines (pastedLines, add = false) {
        this.visible.hotPaste = false // Map data from HotPaste convertedObject to Sigma lines
        if (!(Array.isArray(pastedLines) && pastedLines.length > 0)) return false
        if (!add && pastedLines.length) { // Top replace lines first empty existing lines
          this.existingLines = []
          this.lines = []
          this.buildInitLines()
          this.$emit('hasBeenReset', true)
        }

        pastedLines.forEach(line => {
          this.addExistingLine(line, true, add)
          if (this.entityType === 'ar' && line.form.markup_amount) { // For ARs, Update "amount_with_markups" field
            let lineRef = this.lineByNumber(line.line_number)
            if (lineRef) {
              lineRef.updateAmountWithMarkups()
            }
          }
        })
        this.syncLinesWithParent(this.getValidLines())
        this.isPasted = true
        return true
      },
      /**
       * Automatically adds (or modifies if lineNumber exists) Petty Cash linesbased on the amounts in the PC header
       * @param type
       * @param lineIndex
       * @return {*}
       */
      addPettyCashLines (type, lineIndex, edit = false) {
        const amtEnvelope = this.parentForm.amount_decimal
        const amtAdvanced = this.parentForm.advanced_amount_decimal
        const amtReimbursed = this.parentForm.reimbursed_amount_decimal
        const pcVendor = this.parentForm.vendor
        const pcAccount = this.parentForm.pcAccount
        const cashAccount = this.parentForm.cashAccount
        const pCardAccount = this.parentForm.pCardAccount
        let lineObject, lineObject2
        let vendor_data = this.getVendorById(this.parentForm.vendor.value)
        if (!pcVendor || !pcAccount) return undefined
        if (lineIndex === undefined || lineIndex === false || lineIndex < 0) lineIndex = this.getFirstOpenLine()
        const neg = (val) => (parseFloat(val) * -1).toFixed(2)
        const pos = (val) => parseFloat(val).toFixed(2)
        if (type === 'envelope') {
          if (edit) {
            if (this.lines[lineIndex].form.description.match('PETTYCASH')) {
              lineObject = { // Reduce PC Vendor's advance
                account: { label: pcAccount.code, value: pcAccount.id },
                amount_decimal: (isNumeric(amtEnvelope)) ? neg(amtEnvelope) : '0.00',
                description: 'PETTY CASH OFFSET',
                is_offset: true
              }
            } else if (this.lines[lineIndex].form.description.match('PCARD')) {
              lineObject = { // Reduce PC Vendor's advance
                account: { label: pCardAccount.code, value: pCardAccount.id },
                amount_decimal: (isNumeric(amtEnvelope)) ? neg(amtEnvelope) : '0.00',
                description: 'PCARD OFFSET',
                is_offset: true
              }
            } else {
              if (vendor_data.petty_cash_enabled) {
                lineObject = { // Reduce PC Vendor's advance
                  account: { label: pcAccount.code, value: pcAccount.id },
                  amount_decimal: (isNumeric(amtEnvelope)) ? neg(amtEnvelope) : '0.00',
                  description: 'PETTY CASH OFFSET',
                  is_offset: true
                }
              } else {
                lineObject = { // Reduce PC Vendor's advance
                  account: { label: pCardAccount.code, value: pCardAccount.id },
                  amount_decimal: (isNumeric(amtEnvelope)) ? neg(amtEnvelope) : '0.00',
                  description: 'PCARD OFFSET',
                  is_offset: true
                }
              }
            }
          } else {
            if (vendor_data.petty_cash_enabled) {
              lineObject = { // Reduce PC Vendor's advance
                account: { label: pcAccount.code, value: pcAccount.id },
                amount_decimal: (isNumeric(amtEnvelope)) ? neg(amtEnvelope) : '0.00',
                description: 'PETTY CASH OFFSET',
                is_offset: true
              }
            } else {
              lineObject = { // Reduce PC Vendor's advance
                account: { label: pCardAccount.code, value: pCardAccount.id },
                amount_decimal: (isNumeric(amtEnvelope)) ? neg(amtEnvelope) : '0.00',
                description: 'PCARD OFFSET',
                is_offset: true
              }
            }
          }
        } else if (type === 'advance') {
          lineObject = { // Reduce the amount in cash
            account: { label: cashAccount.code, value: cashAccount.id },
            amount_decimal: (isNumeric(amtAdvanced)) ? neg(amtAdvanced) : '0.00',
            description: 'PETTY CASH ADVANCE FROM BANK',
            is_offset: true
          }
          lineObject2 = { // Add to PC Vendor's advance
            account: { label: pcAccount.code, value: pcAccount.id },
            amount_decimal: (isNumeric(amtAdvanced)) ? pos(amtAdvanced) : '0.00',
            description: 'PETTY CASH ADVANCE TO ' + pcVendor.label,
            is_offset: true
          }
        } else if (type === 'reimbursement') {
          lineObject = { // Add to PC Vendor's advance TODO: Add to check?
            account: { label: pcAccount.code, value: pcAccount.id },
            amount_decimal: (isNumeric(amtReimbursed)) ? pos(amtReimbursed) : '0.00',
            description: 'PETTY CASH REIMBURSEMENT ' + pcVendor.label,
            is_offset: true
          }
        } else {
          return lineIndex
        }
        if (lineObject && lineIndex > -1) { // Merge this.lines with our pasted lines
          let tmpForm1 = Object.assign({}, this.lines[lineIndex].form)
          for (let field in lineObject) {
            const val1 = this.lines[lineIndex].form[field]
            tmpForm1[field] = val1.hasOwnProperty('value')
              ? Object.assign({}, tmpForm1[field], lineObject[field])
              : lineObject[field]
          }
          this.updateLine({ num: lineIndex + 1, form: Object.assign({}, tmpForm1) })
        }
        if (lineObject2 && lineIndex > -1) {
          let tmpForm2 = Object.assign({}, this.lines[lineIndex + 1].form)
          for (let field in lineObject2) {
            const val2 = this.lines[lineIndex].form[field]
            tmpForm2[field] = val2.hasOwnProperty('value')
              ? Object.assign({}, tmpForm2[field], lineObject2[field])
              : lineObject2[field]
          }
          this.updateLine({ num: lineIndex + 2, form: Object.assign({}, tmpForm2) })
        }
        return lineIndex // Let parent component know what line(s) we created so we can modify them later
      },
      /**
       * Builds the initial set of lines
       */
      buildInitLines () {
        this.buildingLines = true
        if (this.existingLines && this.existingLines.length) {
          this.existingLines
            .sort((a, b) => a.line_number - b.line_number)
            .forEach(line => this.addExistingLine(line))
          if (this.lines && this.lines.length < 20) {
            for (let j = 0; j < (20 - this.existingLines.length); j++) {
              this.addNewLine()
            }
          }
        } else {
          for (let i = 0; i < this.initLines; i++) {
            this.addNewLine()
            if (this.lines[i] && this.lines[i].form) {
              this.lines[i].form.line_number = i + 1
              if (this.$store.getters.getAllSets.length) {
                const setData = this.$store.getters.getAllSets.find(v => v.active)
                this.lines[i].form.set = {
                  label: setData.code || '',
                  value: setData.id || ''
                }
              } else {
                this.updateLineDefaultData(i, 'set', 'Sets')
              }
              if (this.$store.getters.getAllLocations.length) {
                const locationData = this.$store.getters.getAllLocations.find(v => v.active)
                this.lines[i].form.location = {
                  label: locationData.code || '',
                  value: locationData.id || ''
                }
              } else {
                this.updateLineDefaultData(i, 'location', 'Locations')
              }
              if (this.$store.getters.getAllSeries.length) {
                const seriesData = this.$store.getters.getAllSeries.find(v => v.active)
                this.lines[i].form.series = {
                  label: seriesData.code || '',
                  value: seriesData.id || ''
                }
              } else {
                this.updateLineDefaultData(i, 'series', 'Series')
              }
              if (this.entityType === 'ar') {
                this.lines[i].form.markup_type = { label: 'Not Set', value: 'NON' }
              }
            }
          }
        }
        this.buildingLines = false
      },
      updateLineDefaultData (lineNumber, field, getter, p = null) {
        if (p) clearTimeout(p)
        if (this.$store.getters[`getAll${getter}`].length) {
          const fieldData = this.$store.getters[`getAll${getter}`].find(v => v.active)
          this.lines[lineNumber].form[field] = {
            label: fieldData.code || '',
            value: fieldData.id || ''
          }
        } else {
          p = setTimeout(() => this.updateLineDefaultData(lineNumber, field, getter), 10)
        }
      },
      /**
       * Builds the form for a given line
       * @param line
       * @return {Object}   The line's form
       */
      buildLineForm (line) {
        const defaultSeries = this.series.find(v => v.active) || {}
        const defaultLocation = this.locations.find(v => v.active) || {}
        const defaultSet = this.sets.find(v => v.active) || {}
        const getFieldVal = (field, getter, prop = 'code', def = null) => {
          if (line && typeof line[field] === 'object' && line[field] != null && line[field].label && line[field].value) return line[field]
          return {
            label: (line && line[field]) ? getter(line[field])[prop] : (def ? def[prop] : ''),
            value: line ? line[field] : (def ? def.id : '')
          }
        }
        const defaultTaxcode = () => {
          let vendor
          let ret = { label: '', value: '' }
          if (this.parentForm.vendor && this.parentForm.vendor.value) {
            vendor = this.getVendorById(this.parentForm.vendor.value)
          }
          if (vendor && vendor.default_tax_code) {
            ret.label = this.$store.getters.getTaxcodeById(vendor.default_tax_code).code
            ret.value = this.$store.getters.getTaxcodeById(vendor.default_tax_code).id
          }
          return ret
        }
        let lineAccount = {}
        if (line && line.account) {
          const existedLine = this.lineAccounts.find(v => { return v.id === line.account })
          if (line.account_code) {
            lineAccount = { label: line.account_code, value: line.account }
            if (existedLine === undefined) {
              this.lineAccounts.push({id: line.account, name: line.account_name})
            }
          } else if (line.code) {
            lineAccount = { label: line.code, value: line.account }
            if (existedLine === undefined) {
              this.lineAccounts.push({id: line.account, name: line.account_name})
            }
          } else {
            lineAccount = getFieldVal('account', this.getAccountById)
          }
        }
        let form = {
          description: line && line.description ? line.description : '',
          amount_decimal: line && line.amount_decimal ? line.amount_decimal : '',
          remaining_decimal: line && line.remaining_decimal ? line.remaining_decimal : '',
          asset: line && line.asset ? line.asset : false,
          is_offset: line && line.is_offset ? line.is_offset : false,
          account: lineAccount,
          series: getFieldVal('series', this.getSeriesById, 'code', defaultSeries),
          location: getFieldVal('location', this.getLocationById, 'code', defaultLocation),
          set: getFieldVal('set', this.getSetById, 'code', defaultSet),
          tax_code: {
            label: (line && line.tax_code) ? this.getTaxcodeById(line.tax_code).code : (line ? '' : defaultTaxcode().label),
            value: (line && line.tax_code) ? line.tax_code : (line ? '' : defaultTaxcode().value)
          },
          free_field_1: {
            label: (line && line.free_field_1) ? this.getFreefieldById(line.free_field_1).code : '',
            value: (line && line.free_field_1) ? line.free_field_1 : ''
          },
          free_field_2: {
            label: (line && line.free_field_2) ? this.getFreefieldById(line.free_field_2).code : '',
            value: (line && line.free_field_2) ? line.free_field_2 : ''
          },
          free_field_3: {
            label: (line && line.free_field_3) ? this.getFreefieldById(line.free_field_3).code : '',
            value: (line && line.free_field_3) ? line.free_field_3 : ''
          },
          free_field_4: {
            label: (line && line.free_field_4) ? this.getFreefieldById(line.free_field_4).code : '',
            value: (line && line.free_field_4) ? line.free_field_4 : ''
          },
          third_party_vendor: {
            label: (line && line.third_party_vendor) ? this.getVendorById(line.third_party_vendor).code : '',
            value: (line && line.third_party_vendor) ? line.third_party_vendor : ''
          }
        }
        switch (this.entityType) {
          case 'je':
          case 'ap':
          case 'pc':
            const reliefLine = line && line.relieves ? this.getPoLineById(line.relieves) : {}
            form.relieves = {
              label: reliefLine.meta_name || '',
              value: line && line.relieves ? line.relieves : ''
            }
            form.other_name = line && line.other_name ? line.other_name : ''
            break
          case 'po':
            form.other_name = line && line.other_name ? line.other_name : ''
            break
          case 'ar':
            form = this.setArLineProperties(line, form)
            break
          case 'bp':
            form = this.setBpLineProperties(line, form, getFieldVal)
        }
        if (line && line.hasOwnProperty('id')) { // Check if the original line object contains an ID. If so, add an ID property to the line form. This is useful if we're editing distribution lines
          form['id'] = line.id
          if (this.entityType === 'po') {
            form.type = line && line.type ? line.type : 'OPEN'
          } else if (this.entityType === 'ar' || this.entityType === 'bp') {
            form.type = line && line.type ? line.type : ''
          }
        }
        if (line && line.hasOwnProperty('original_line_id')) { // If this line is a DC, then the original line will actually be the DC line,
          form['original_line_id'] = line.original_line_id // but we can reference the original trx line with 'original_line_id'
        }
        if (this.entityType === 'po' && line && line.hasOwnProperty('source_type')) {
          form.source_type = line.source_type
        }
        if (this.entityType === 'ap') {
          this.$emit('setApBankAttributes')
        }
        if (this.entityType === 'po' && line && line.hasOwnProperty('close_reopen_id')) {
          form.close_reopen_id = line.close_reopen_id
        }
        return form
      },
      /**
       * Sets AR-specific properties on the line form
       * @param line
       * @param form
       */
      setArLineProperties (line, form) {
        delete form.tax_code
        delete form.third_party_vendor
        delete form.asset
        form.markup_type = {
          label: (line && line.markup_type) ? line.markup_type : 'Not Set',
          value: (line && line.markup_type) ? line.markup_type : 'NON'
        }
        form.item = {
          label: (line && line.item) ? this.getBillableitemById(line.item).code : '',
          value: (line && line.item) ? line.item : ''
        }
        form.markup_amount = line && line.markup_amount ? line.markup_amount : this.setInitialMarkupAmount(line)
        form.amount_with_markups_decimal = line && line.amount_with_markups_decimal ? line.amount_with_markups_decimal : ''
        form.referencing_line = line && line.referencing_line ? line.referencing_line : ''
        return Object.assign({}, form)
      },
      /**
       * Sets BP-specific properties on the line form
       * @param line
       * @param form
       * @param getFieldVal
       */
      setBpLineProperties (line, form, getFieldVal) {
        if (line && !line.account) {
          const bank = this.parentForm.batch.value ? this.getBankByBatchId(this.parentForm.batch.value) : null
          let account = bank ? this.getAccountById(bank.default_account_deposits) : null
          if (account) {
            form.account = { label: account.code, value: account.id }
          }
        }
        form.bill = line && line.bill ? getFieldVal('bill', this.getArById, 'meta_name') : ''
        form.prepayment = line && line.prepayment ? getFieldVal('prepayment', this.getPpById, 'meta_name') : ''
        return Object.assign({}, form)
      },
      /**
       * Sets the form.markup_amount field value of an existing line, based on that line's markup_type and
       * corresponding markup_rate or markup_amount_decimal.
       * @param line
       */
      setInitialMarkupAmount (line) {
        if (line && line.markup_type) {
          if (line.markup_type === 'PCT') return line.markup_rate
          if (line.markup_type === 'AMT') return line.markup_amount_decimal
        }
        return ''
      },
      /**
       * Resets changes to all lines
       */
      resetAllLineChanges () {
        this.lineComponents().forEach(line => line.resetChanges())
      },
      /**
       * Updates the "originalLine" object on each line
       */
      updateOriginalLineFlags () {
        this.lineComponents().forEach(line => line.setOriginalLine())
      },
      /**
       * Fetches inherited markup type and amount based on billable item selection
       * @param data    An object with properties lineNumber and item, representing the line number and billable item selected
       */
      async fetchInheritedMarkupData ({ lineNumber, item }) {
        if (!(item && this.parentForm.customer.value)) return
        if (!this.inheritedMarkupData[item]) {
          try {
            const { customer, batch } = this.parentForm
            const bank = this.getBankByBatchId(batch.value)
            const payload = {
              query: { billable_item: item, customer: customer.value, currency: bank.currency }
            }
            const resp = await this.$store.dispatch('fetchInheritedMarkups', payload)
            if (resp && resp.ok && resp.data) {
              this.inheritedMarkupData[item] = resp.data
            }
          } catch (e) {
            console.log(e)
          }
        }
        this.setInheritedMarkupData(lineNumber, item)
      },
      /**
       * Sets inherited markup type and amount based on billable item selection
       * @param lineNumber  The number of the line for which to set inherited markup type and amount
       * @param item        The selected billable item id
       */
      setInheritedMarkupData (lineNumber, item) {
        if (!this.inheritedMarkupData[item] || !this.lines[lineNumber - 1]) return
        let { markup_type, markup_rate, markup_amount } = this.inheritedMarkupData[item]
        let lineRef = this.lineByNumber(lineNumber)
        if (lineRef && typeof lineRef.modifyLine === 'function' && !!markup_type) {
          let amt, mType
          if (markup_type === 'PCT') {
            mType = 'Percentage'
            amt = markup_rate
          } else if (markup_type === 'AMT') {
            mType = 'Amount'
            amt = markup_amount
          } else {
            mType = 'Not Set'
            amt = ''
          }
          lineRef.modifyLine('markup_type', { label: mType, value: markup_type || 'NON' })
          lineRef.modifyLine('markup_amount', amt)
          lineRef.updateAmountWithMarkups()
        }
      },
      /**
       * Inserts n lines at the specified lineNumber
       */
      insertLinesAtPosition ({ lineNumber, numberOfLinesToInsert }) {
        let i = 1
        while (i <= numberOfLinesToInsert) {
          const newLine = { line_number: null, form: this.buildLineForm() }
          this.lines.splice(parseInt(lineNumber), 0, newLine)
          i++
        }
        this.lines = this.lines.map((line, index) => {
          line.line_number = index + 1
          return line
        })
        this.syncLinesWithParent(this.lines)
        this.$emit('linesInserted', { lineNumber, numberOfLinesToInsert })
      },
      /**
       * Rebuilds the distribution lines
       */
      rebuildLines () {
        this.$nextTick(() => {
          this.lines = []
          this.isPasted = false
          this.buildInitLines()
        })
      },
      /**
      * Creates delete requests
      * @return {*}
      */
      async deleteClearedLines (lineDeltas) {
        const type = this.entityType
        let promises = lineDeltas.map(line => this.$store.dispatch('deleteLine', { id: line.form.id, type }))
        try {
          const resp = await Promise.all(promises)
          if (!(resp && resp.length === lineDeltas.length)) {
            throw new Error('Error deleting lines')
          }
          return resp
        } catch (e) {
          console.log(e)
          return e
        }
      }
    },
    computed: {
      ...mapGetters({
        getAccounts: 'getAccounts',
        getAccountById: 'getAccountById',
        getApLines: 'getApLines',
        series: 'getAllSeries',
        getSeriesById: 'getSeriesById',
        locations: 'getAllLocations',
        getLocationById: 'getLocationById',
        sets: 'getAllSets',
        getSetById: 'getSetById',
        taxcodes: 'getAllTaxcodes',
        getTaxcodeById: 'getTaxcodeById',
        freefields: 'getAllFreefields',
        getFreefieldById: 'getFreefieldById',
        getVendorById: 'getVendorById',
        getPoLineById: 'getPoLineById',
        getBillableitemById: 'getBillableitemById',
        billableitems: 'getAllBillableitem',
        getBankByBatchId: 'getBankByBatchId',
        getApById: 'getApById',
        getPpById: 'getPpById',
        getPcById: 'getPcById',
        getJeById: 'getJeById',
        getPoById: 'getPoById'
      }),
      /**
       * Returns a boolean indicating whether a modal is currently being shown in the foreground
       * @return boolean
       */
      modalVisible () {
        const visible = this.$store.getters.getModalVisibilityState
        return Object.values(visible).some(v => v.visible)
      },
      /**
       * Returns a boolean indicating whether the delete button should be shown
       * @return boolean
       */
      hideDeleteBtn () {
        let prohibited = ['POSTED', 'CLOSED', 'VOIDED']
        return (this.parentForm && this.parentForm.status && prohibited.includes(this.parentForm.status))
      },
      /**
       * Returns a boolean indicating whether to allow the user to add a new line. Does not allow line additions as DCs.
       * @return boolean
       */
      preventAddLine () {
        const notAllowed = ['POSTED', 'CLOSED', 'VOIDED', 'DELETED']
        return (this.entityType !== 'po' && notAllowed.includes(this.parentForm.status))
      },
      /**
       * Returns a boolean indicating whether to allow the user for paste values. Does not allow line additions as DCs.
       * @return boolean
       */
      preventPasteValues () {
        const notAllowed = ['POSTED', 'CLOSED', 'VOIDED', 'DELETED']
        return (this.entityType !== 'bp' && !notAllowed.includes(this.parentForm.status))
      },
      /**
       * Returns a boolean indicating whether one or more lines have had distribution changes made to them
       * @return boolean
       */
      linesContainDcs () {
        const { parentForm, existingLines } = this
        return !this.trxIsADcJournalEntry &&
          ['DRAFT', 'OPEN', 'AUDITED', 'POSTED', 'CLOSED'].includes(parentForm.status) &&
          existingLines.some(line => line && line.form && line.form.offset_by)
      },
      /**
       * Returns a boolean indicating whether this transaction is a DC Journal Entry
       * @return {boolean}
       */
      trxIsADcJournalEntry () {
        const { parentForm, entityType } = this
        if (entityType !== 'je') {
          return false
        }
        const dcSourceCode = this.$store.getters.getDcSourceCode.id
        const parentFormSourceCode = parentForm.source_code && parentForm.source_code.hasOwnProperty('value')
          ? parentForm.source_code.value
          : parentForm.source_code
        return parentFormSourceCode === dcSourceCode
      }
    },
    watch: {
      closedPoLineToUpdate () {
        if (this.closedPoLineToUpdate && this.lines.find(v => v.form.id === this.closedPoLineToUpdate)) {
          this.lines.forEach(line => {
            if (line.form.id === this.closedPoLineToUpdate) {
              line.form = this.buildLineForm(this.existingLines.find(existingLine => existingLine.id === line.form.id))
            }
          })
        }
        this.$emit('resetPoLineToUpdate')
      },
      reset () { // clears the lines component
        if (this.reset) {
          this.lines = []
          this.errors = []
          this.loading = false
          this.loadingOpts = false
          this.lineAdded = false
          this.preventEmitUpdateEvent = false
          this.isPasted = false
          this.buildInitLines()
          this.$emit('hasBeenReset', true)
        }
      }
    },
    created () {
      this.buildInitLines()
    },
    mounted () {
      this.bindMousetrapToNavKeys()
      this.$emit('mounted') // Need to allow transaction to act on lines which are typically created well afterward
    }
  }
</script>

<style>
  td input {
    border: none !important;
    height: 22px !important;
    text-align: left;
  }
  td textarea {
    border: none !important;
    height: 22px !important;
  }
  .el-input {
    font-size: 12px;
  }
  .el-form .el-select {
    width: 100%;
  }
  .el-select .el-input__inner {
    padding-right: 0;
  }
  .right .el-input__inner {
    text-align: right !important;
  }
  .distribution-line input {
    text-overflow: ellipsis;
  }
</style>

<style scoped>
  /*Table style properties*/
  table {
    width: 100%;
    margin-bottom: 1em;
    border-collapse: collapse;
  }
  td {
    padding: 0.2em;
    font-size: 13px;
    border: 1px solid #ccc;
  }
  td:not(.data-row) {
    background-color: #efefef;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .data-row {
    background-color: #ffffff;
  }
  /*Non-table related properties*/
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
</style>
